import type { ElectedRole } from "../../api/members";

interface ElectedRoleBadgesProps {
  roles?: ElectedRole[];
  variant?: "compact" | "detailed";
}

const ROLE_LABELS: Record<ElectedRole, string> = {
  diretoria: "Diretoria",
  conselho_deliberativo: "Conselho Deliberativo",
  conselho_fiscal: "Conselho Fiscal",
};

export function electedRoleLabel(role: ElectedRole): string {
  return ROLE_LABELS[role];
}

export function ElectedRoleBadges({ roles = [], variant = "compact" }: ElectedRoleBadgesProps) {
  if (roles.length === 0) return null;

  return (
    <span className={`elected-role-badges elected-role-badges--${variant}`} aria-label="Cargos eletivos ativos">
      {roles.map((role) => (
        <span key={role} className="elected-role-badge">
          {ROLE_LABELS[role]}
        </span>
      ))}
    </span>
  );
}
